export const UTILITY_BILLS_ABSOLUTE_PATH = "/documents/summary";

export const UTILITY_BILL_PAGE = {
  ABSOLUTE_PATH: (billId: string) => `${UTILITY_BILLS_ABSOLUTE_PATH}/${billId}`,
  PATH: ":billId",
  KEY: "billId",
} as const;


